import { push } from "react-router-redux";
import { USE_IDENTITY_SERVER } from "../_config";
import entraUserManager from "../utils/entraUserManager";
import userManager from "../utils/userManager";
import _ from "lodash";

class UserHelper {
    static getUserManager() {
        return USE_IDENTITY_SERVER ? userManager : entraUserManager;
    }

    static async getUser() {
        const manager = this.getUserManager();
        return await manager.getUser();
    }

    static async getValidUser() {
        const manager = this.getUserManager();
        let user = await manager.getUser();
        if (!user || user.expired) {
            try {
                console.info("[UserHelper] User expired or not found, attempting silent signin");
                user = await manager.signinSilent();
            } catch (error) {
                console.error("[UserHelper] Error getting valid user:", error);

                console.info("[UserHelper] Signing user out");
                manager.removeUser().then(function(){
                    console.info("[UserHelper] Redirecting to signin");
                    manager.signoutRedirect({ 'id_token_hint': _.get(user, 'id_token')});
                });
                user =  null;
            }
        } else {
            console.info("[UserHelper] User is valid");
        }
        return user;
    }

    static async getUserId() {
        const user = await this.getUser();
        return this.getExtensionUserId(user);
    }

    static getExtensionUserId(user) {
        return user && user.profile && (user.profile.extension_userId || user.profile.extension_user_id);
    }
}

export default UserHelper;